import {
  FACET_ADDED,
  FACET_SHOW_ALL,
  FACET_REMOVED,
  FACET_RESET,
  FACET_SEARCH_WITH_AREA_FILTER,
} from '../action-types/facetActionTypes';

import { searchSelectedAreaFilterReset } from '../../actions/search';

const facetAddedAction = (facets) => ({
  type: FACET_ADDED,
  facets,
});

export const facetRemovedAction = (facets) => ({
  type: FACET_REMOVED,
  facets,
});

export const facetShowAllAction = (facets) => ({
  type: FACET_SHOW_ALL,
  facets,
});

export const facetResetAction = () => ({
  type: FACET_RESET,
  showAllButtonVisible: false,
});

export const facetSearchWithAreaFilter = () => ({
  type: FACET_SEARCH_WITH_AREA_FILTER,
});

export const updateFacets = (dispatch, getState, filters, filterUpdate) => {
  const facets = getState().facetData.facets;
  const selectedAreaFilter = getState().search.selectedAreaFilter;

  let facetLength = getState().facetData.facetLength;

  //add
  if (filterUpdate.area !== 'pubYears') {
    const f = (filters[filterUpdate.area] || []).filter(
      (filter) => filter.key.id === filterUpdate.id
    );
    if (f && f.length > 0) {
      if( filterUpdate.area === 'inclusions')
      {        
        if (f[0].key.id === 'true') {
          f[0].key.title = 'Only Guidelines with Profiles / Scorecards';
        }

        if (f[0].key.id === 'false') {
          f[0].key.title = 'Only Guidelines without Profiles / Scorecards';
        }
      }
      else if( filterUpdate.area === 'systematicReviews')
      {        
        if (f[0].key.id === 'true') {       
          f[0].key.title = 'Systematic Review Conducted';
        }
      }
      else if( filterUpdate.area === 'guidelineQuality')
      {        
        if (f[0].key.id === 'true') {          
          f[0].key.title = 'Quality of Evidence Rated';
        }
      }
      else if( filterUpdate.area === 'guidelineRateQuality')
      {        
        if (f[0].key.id === 'true') {          
          f[0].key.title = 'Strength of Recommendations Rated';
        }
      }          

      if (filterUpdate.area === 'systematicReviews' || filterUpdate.area === 'guidelineQuality' || filterUpdate.area === 'guidelineRateQuality') {
        const facet = {
          id: filterUpdate.area,          
          title: f[0].key.title,
          area: filterUpdate.area,
        };
        if (filterUpdate.newValue) {
          facets.push(facet);

          dispatch(
            facetAddedAction(facets, facet.title.length, facetLength > 200)
          );
        }
      }
      else
      {
        const facet = {
          id: f[0].key.id,
          title: f[0].key.title,
          area: filterUpdate.area,
        };
        if (filterUpdate.newValue) {
          const exist = facets.find((f) => f.id === facet.id);
          if (!exist) {
            facets.push(facet);
          }

          dispatch(
            facetAddedAction(facets, facet.title.length, facetLength > 200)
          );
        }
      }
    }
  }

  if (filterUpdate.area === 'pubYears') {
    const f = Object.keys(filters['pubYears'] || {}).filter((year) => {
      return year === filterUpdate.id;
    });

    if (f && f.length > 0) {
      const facet = {
        id: f[0],
        title: f[0],
        area: 'pubYears',
      };
      if (filterUpdate.newValue) {
        const exist = facets.find((f) => f.id === facet.id);

        if (!exist) {
          facets.push(facet);
        }

        dispatch(
          facetAddedAction(facets, facet.title.length, facetLength > 200)
        );
      }
    }
  }

  //remove
  if (filterUpdate.area === 'systematicReviews' || filterUpdate.area === 'guidelineQuality' || filterUpdate.area === 'guidelineRateQuality') {    
    if (filterUpdate.newValue === false) {
      const result = facets.filter(function (facet) {
        if (facet.id === filterUpdate.area) {
        }
        return facet.id !== filterUpdate.area;
      });

      const removedFacet = facets.filter((f) => f.id === filterUpdate.area)[0];      
      
      if (selectedAreaFilter && selectedAreaFilter.area === removedFacet.id) {
        dispatch(searchSelectedAreaFilterReset());
      }
      
      dispatch(
        facetRemovedAction(result, removedFacet.title.length, facetLength < 200)
      );
    }
  }
  else
  {
    if (filterUpdate.newValue === false) {
      const result = facets.filter(function (facet) {
        if (facet.id === filterUpdate.id) {
        }
        return facet.id !== filterUpdate.id;
      });
  
      const removedFacet = facets.filter((f) => f.id === filterUpdate.id)[0];
  
      if (selectedAreaFilter && selectedAreaFilter.id === removedFacet.id) {
        dispatch(searchSelectedAreaFilterReset());
      }

      dispatch(
        facetRemovedAction(result, removedFacet.title.length, facetLength < 200)
      );
    }
  }
};

const actionCreators = {
  resetFacets: () => (dispatch) => {
    dispatch(facetResetAction());
  },
  showAllFacets: () => (dispatch, getState) => {
    const currentFilters = getState().search.filters;
    const facets = [];

    const pubYears = currentFilters.pubYears || {};

    Object.keys(pubYears).forEach((year) => {
      if (pubYears[year].selected) {
        const facet = {
          id: year,
          title: year,
          area: 'pubYears',
        };

        facets.push(facet);
      }
    });

    Object.keys(currentFilters).forEach((filterKey) => {
      if (filterKey !== 'pubYears') {
        const filters = currentFilters[filterKey] || [];

        filters.forEach((filter) => {
          if (filter.selected) {
            if(filterKey === 'inclusions')
            {
              if (filter.key.id === 'true') {
                filter.key.title = 'Only Guidelines with Profiles / Scorecards';
              }

              if (filter.key.id === 'false') {
                filter.key.title = 'Only Guidelines without Profiles / Scorecards';
              }
            }
            else if(filterKey === 'systematicReviews')
            {
              if (filter.key.id === 'true') {
                filter.key.title = 'Systematic Review Conducted';
              }
            }
            else if(filterKey === 'guidelineQuality')
            {
              if (filter.key.id === 'true') {
                filter.key.title = 'Quality of Evidence Rated';
              }
            }
            else if(filterKey === 'guidelineRateQuality')
            {
              if (filter.key.id === 'true') {
                filter.key.title = 'Strength of Recommendations Rated';
              }
            }

            const facet = {
              id: filter.key.id,              
              title: filter.key.title,
              area: filterKey,
            };

            facets.push(facet);
          }
        });
      }
    });

    dispatch(facetShowAllAction(facets));
  },
};

export default actionCreators;
